import {Box} from "@mui/material";
import ClientProfileSection from "./client/ClientProfileSection";
import ClientTrainerSection from "./client/ClientTrainerSection";
import ClientPlansSection from "./client/ClientPlansSection";

const ClientPageProfile = ({handleReload, client, coach = false}) => {
  return (
      <Box sx={{display: "flex", flexDirection: "column", gap: coach ? "18px" : 2.5, mt: coach ? 0 : 2.5}}>
        <ClientProfileSection refetch={handleReload} client={client} coach={coach}/>
        <ClientTrainerSection refetch={handleReload} client={client} coach={coach}/>
        <ClientPlansSection handleReload={handleReload} client={client} coach={coach}/>
      </Box>
  );
};

export default ClientPageProfile;
